import Config from '../Config';
import { RestService } from './RestService';

export const JobActionService = {
    getJobActions: async function(project_id){
        return RestService.get(`${Config.get_job_actions}${project_id ? `project_id=${project_id}` : ''}`, {})
        .then(response => response.json());
    },
    createJobAction: async function(headers, jobAction){
        return RestService.post(`${Config.create_job_action}`, headers , jobAction);
    },
    removeJobAction: async function(headers, id){
        return RestService.post(`${Config.remove_job_action}id=${id}`, headers, undefined);
    }
};